export const phoneFormation = str => {
  const phone = str?.replace('(', ' (').replace(')', ') ').replaceAll('  ', ' ');
  let url = str?.replace(' (', '(').replace(') ', ')').split(' ')[0] || str?.replace(' (', '(').replace(') ', ')');
  url = 'tel:' + url;
  return { phone, url };
};

export const phoneFormationBack = str => {
  return str?.replace(' (', '').replace(') ', '').replaceAll(' ', '').replaceAll('-', '');
};

export const cleanPhone = (phone: string): string => {
  if (typeof phone !== 'string' || !phone) {
    return '';
  }
  const numberPattern = /[^\d+]/g;
  return phone.replace(numberPattern, '').toString();
};
